import MyPokeContainer from "./MyPokeContainer";

export default MyPokeContainer;